var _path, _g, _path2, _path3, _ellipse, _g2, _ellipse2, _g3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoResultsRejseklubben = function SvgNoResultsRejseklubben(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 120 121"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "noResults-rejseklubben_svg__a",
    width: 53,
    height: 67,
    x: 51,
    y: 46,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M61.616 56.82c-.46.684-1.983 3.048-2.343 3.755-5.28 10.045-9.838 47.806-7.278 51.814l.137.212.04.06c1.767 1.86 37.778-17.917 45.176-26.889.5-.625 2.092-2.948 2.552-3.633a23.08 23.08 0 0 0 .136-25.265 22.9 22.9 0 0 0-6.591-6.633c-7.872-5.156-17.799-4.853-25.223-.032a23 23 0 0 0-6.656 6.6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#noResults-rejseklubben_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#noResults-rejseklubben_svg__b)",
    d: "m87.636 37.645-59.21 38.45 26.788 41.25 59.209-38.45z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "noResults-rejseklubben_svg__c",
    width: 57,
    height: 90,
    x: 13,
    y: 23,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.506 46.083c-.646 3.384-.703 6.944.02 10.513.188.952.874 4.33 1.172 5.254 1.2 3.903 4.485 9.89 8.704 16.387 9.243 14.234 22.848 31.005 27.934 34.06.557.327.946.461 1.286.454 6.55.601 16.642-47.412 16.438-61.457-.026-1.831-.29-3.764-.96-6.122-.948-3.251-2.29-6.247-4.037-8.936-6.103-9.398-16.708-14.584-28.494-12.3-3.083.626-5.981 1.735-8.544 3.228l-1.212.787a28.14 28.14 0 0 0-12.257 18.142"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#noResults-rejseklubben_svg__c)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#noResults-rejseklubben_svg__d)",
    d: "m5.625 7.664-12.99 104.638 100.673 12.225 12.99-104.638z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "noResults-rejseklubben_svg__f",
    width: 34,
    height: 55,
    x: 24,
    y: 37,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.303,
    cy: 27.745,
    fill: "url(#noResults-rejseklubben_svg__e)",
    rx: 15.303,
    ry: 27.745,
    transform: "matrix(.96086 -.28256 .2842 .95715 18.274 42.31)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#noResults-rejseklubben_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A26CAB",
    d: "M38.384 37.799c-4.311 10.862 2.795 38.45 6.887 50.888l8.242 3.003L61.9 57.523z",
    opacity: 0.6
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "noResults-rejseklubben_svg__h",
    width: 31,
    height: 41,
    x: 62,
    y: 53,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.591,
    cy: 73.349,
    fill: "url(#noResults-rejseklubben_svg__g)",
    rx: 12.102,
    ry: 21.996,
    transform: "matrix(.86518 .47362 -.53093 .86518 49.404 -26.86)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#noResults-rejseklubben_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A26DAC",
    d: "M91.698 57.383c-8.65 3.44-20.737 22.537-25.7 31.655L68.77 95.4l24.377-13.79z",
    opacity: 0.9
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD513",
    d: "M90 29q-1.714 0-2.857-1.123Q86 26.71 86 25.006t1.143-2.83q1.143-1.164 2.857-1.164t2.857 1.165Q94 23.3 94 25.006t-1.143 2.87Q91.714 29.002 90 29m-2.939-9.735L86 1h7.878l-.898 18.265z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "noResults-rejseklubben_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 27.7449 -15.3034 0 15.303 27.745)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "noResults-rejseklubben_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 21.996 -12.1022 0 75.501 74.632)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noResults-rejseklubben_svg__b",
    x1: 45.248,
    x2: 104.427,
    y1: 96.591,
    y2: 58.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8B8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#B798C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9F66A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8B8DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noResults-rejseklubben_svg__d",
    x1: 39.92,
    x2: 50.47,
    y1: 116.017,
    y2: 29.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E65A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C8B8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8B8DB"
  })))));
};
export default SvgNoResultsRejseklubben;